<sgt-multi-select
  [options]="options"
  [settings]="settings"
  [variante]="variante"
  [icon]="icon"
  [(ngModel)]="idsEstados"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()"
  (isFirstOpened)="firstOpened($event)">
</sgt-multi-select>
